import api from '@/lib/axios';

export const pagosProveedoresService = {
  async findAll(params: {
    companyId: string; supplierId?: string; purchaseOrderId?: string;
    page?: number; limit?: number;
  }) {
    const response = await api.get('/supplier-payments', { params });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/supplier-payments/${id}`);
    return response.data;
  },

  async create(data: {
    companyId: string; supplierId: string; purchaseOrderId?: string;
    amount: number; paymentMethod?: string; reference?: string; notes?: string;
    createdById?: string;
  }) {
    const response = await api.post('/supplier-payments', data);
    return response.data;
  },

  async getBalance(supplierId: string, companyId: string) {
    const response = await api.get(`/supplier-payments/balance/${supplierId}`, { params: { companyId } });
    return response.data;
  },
};
